import { supabase } from '@/integrations/supabase/client';

interface TriggerAutomationParams {
  jobId: string;
  oldStatus: string;
  newStatus: string;
  workflowType: 'retail' | 'insurance' | 'commercial';
}

export const triggerWorkflowAutomations = async ({
  jobId,
  oldStatus,
  newStatus,
  workflowType,
}: TriggerAutomationParams) => {
  try {
    console.log('Triggering workflow automations:', { jobId, oldStatus, newStatus, workflowType });

    const { data, error } = await supabase.functions.invoke('execute-workflow-automation', {
      body: {
        jobId,
        oldStatus,
        newStatus,
        workflowType,
      },
    });

    if (error) {
      console.error('Error triggering automations:', error);
      return { success: false, error };
    }

    console.log('Automation triggered successfully:', data);
    return { success: true, data };
  } catch (error) {
    console.error('Failed to trigger automations:', error);
    return { success: false, error };
  }
};
